import { IconsModel } from "../models/icons/iconsModel";
import { faCartShopping, faXmarkLarge } from "@fortawesome/pro-solid-svg-icons";

const pluginCheckoutIconsLarge = {
    addButtonIcon: {
        inStock: faCartShopping,
        outOfStock: faCartShopping,
        preorder: faCartShopping,
        discontinued: faCartShopping,
    },
};

const pluginCheckoutIconsMedium = {
    addButtonIcon: {
        inStock: faCartShopping,
        outOfStock: faCartShopping,
        preorder: faCartShopping,
        discontinued: faCartShopping,
    },
};

export const icons: IconsModel = {
    pluginCheckoutIconsLarge: pluginCheckoutIconsLarge,
    pluginCheckoutIconsMedium: pluginCheckoutIconsMedium,
    cartIcon: faCartShopping,
    iconQuickCartCloseBtn: faXmarkLarge
};
